<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="SeHouseholdSetup"
    seFeDataSubtitle="Household setup app and libs"
    size="750">
  </se-fe-header>
  <div seFePageContent>

    <router-outlet></router-outlet>

  </div>
</se-fe-page>
